
import * as actionTypes from '../constants/actionType';
import initialState from './initialState';

export default function pageReducer(state = initialState.page, action) {
  switch (action.type) {
    case actionTypes.PAGE_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.PAGE_LOAD_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false
      };

    case actionTypes.PAGE_LOAD_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        isLoaded: true
      };

    default: {
      return state;
    }
  }
}
